import React from 'react';
import './Styles/Card.scss';
import {Link} from 'react-router-dom';
import {AiOutlineDownload} from 'react-icons/ai';
const Card=(props)=>{
    return(
        <div className="ebook-card" data-aos="fade-up"
        data-aos-delay={100}>
            <div className="image">
                <img src={props.image} />
            </div>
            <div className="line"></div>
            <div className="content">
                <h1>{props.title}</h1>
                <p>{props.desc}</p>
                <Link to="ebooks"><AiOutlineDownload className="icon" /> Download for free</Link>
            </div>
        </div>
    )
};
export default Card ;